import { connect } from 'react-redux';

import { renameScript } from 'scripts';
import { getActiveScriptId, getRenameModal } from 'current/selectors';
import { closeRenameModal, updateRenameInputValue } from 'current/uiwidgets/';
import { getRenameScriptValidationResult } from 'validations/selectors';

import RenameModal from './RenameModal';

export default connect(
  (state) => {
    return {
      renameModal: getRenameModal(state),
      scriptId: getActiveScriptId(state),
      validationResult: getRenameScriptValidationResult(state)
    };
  },
  (dispatch) => {
    return {
      onCancelRenameModal: () => {
        dispatch(closeRenameModal());
      },
      onChangeRenameInput: (newValue) => {
        dispatch(updateRenameInputValue(newValue));
      },
      onSaveRenameModal: ({ scriptId }) => {
        dispatch(renameScript({ scriptId }));
      }
    };
  }
)(RenameModal);
